<shrd-pf-ft-search-input
  [usePreloader]="isFocused"
  [loading]="isLoading$ | async"
  (focusChange)="$event ? onInputFocusIn() : onInputFocusOut()"
></shrd-pf-ft-search-input>

<ng-container *shrdUtcLet="suggestions$ | async as suggestions">
  <div #flyout *ngIf="hasFlyout" @showFlyout class="shrd-uic-flyout-popover popover white-arrow position-absolute">
    <div class="popover-body">
      <div class="arrow"></div>
      <shrd-uic-flyout-body
        [scrollbarEnabled]="false"
        [hasGrid]="false"
        [focusEnabled]="true"
        class="py-0"
        shrdPfFtSelectableLinks
        (selectableLinksUpdated)="updateLinkNodes($event)"
      >
        <div
          class="main-content-block content-box p-0 border-bottom border-neutral-light"
          shrdUicScrollbar
          [scrollBarVerticalRef]="scrollbar"
        >
          <div class="d-flex main-content-gap">
            <div class="overflow-hidden">
              <div class="search-content-block pt-md-2 pb-md-1 px-3">
                <shrd-pf-ft-search-products></shrd-pf-ft-search-products>
              </div>
            </div>
            <div class="overflow-hidden bg-neutral-megalight">
              <shrd-pf-ft-search-categories
                class="search-content-block h-100 pt-md-2 pb-md-1 px-3"
              ></shrd-pf-ft-search-categories>
            </div>
          </div>
          <shrd-uic-scrollbar #scrollbar class="main-content-block-scrollbar"></shrd-uic-scrollbar>
        </div>
        <div class="d-flex content-box" *ngIf="suggestions.hasSuggestions">
          <div class="overflow-hidden">
            <a
              *shrdUtcLet="searchTerm$ | async as searchTerm"
              shrdUicButton
              variant="tertiaryMinorBorderless"
              [href]="suggestions.searchUrl"
              class="m-0 bl-min-h-5 see-more"
              [shrdUtcTrackEvent]="{
                category: 'ProductInfo',
                action: 'FindProducts',
                label: 'SiteSearchStandard|' + searchTerm + '|See all results'
              }"
            >
              <shrd-uic-svg-icon icon="arrow-right" size="small" />
              <span>{{ 'header.search.viewAll' | i18next }}</span>
            </a>
          </div>
        </div>
      </shrd-uic-flyout-body>
    </div>
  </div>
</ng-container>
